import PropTypes from 'prop-types';
import { Card, Row, Col } from 'antd';
import { GUIAS_VISITAS, GUIAS_MEDIOS_IMPRESOS } from 'constants/guiasTypes';
import ArrowForward from 'assets/images/GuiasUsuarios/arrow_forward.svg';
import './ButtonCard.scss';

const ButtonCard = ({ idGuideType, guiadeType, guiadeLogo, handleScreen }) => {
  const handleMarginTop = () => {
    switch (idGuideType) {
      case GUIAS_MEDIOS_IMPRESOS.value:
        return '-27px';
      case GUIAS_VISITAS.value:
        return '-27px';
      default:
        return '-15px';
    }
  };
  const style = {
    marginTop: handleMarginTop(),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };
  const handleClick = () => {
    handleScreen(idGuideType, guiadeLogo, guiadeType);
  };
  return (
    <div>
      <Card
        className="card-container"
        style={{ height: '105px', width: '320px', boxShadow: '0 1.5px 1px 1px rgb(0 0 10 / 15%)' }}
        onClick={handleClick}>
        <Row gutter={[0, 0]} style={style}>
          <Col span={6}>
            <div className="image-card">
              <img src={guiadeLogo} alt="" />
            </div>
          </Col>
          <Col span={12}>
            <div className="name-card-container">
              <p>{guiadeType}</p>
            </div>
          </Col>
          <Col span={6}>
            <img className="btn-navigator-link" src={ArrowForward} alt="Botón Navigator" />
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default ButtonCard;

ButtonCard.propTypes = {
  idGuideType: PropTypes.number.isRequired,
  guiadeType: PropTypes.string.isRequired,
  guiadeLogo: PropTypes.string.isRequired,
  handleScreen: PropTypes.func.isRequired
};
